import React, { Component } from 'react';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../actions/settings';

class UpdateBillingEmailForm extends Component {
	constructor(props) {
		super(props);
		this.submit = this.submit.bind(this);
		this.history = this.props.history;
		this.state = { loading: false, newEmail: '', errorMessage: '' };
	}

	async submit() {
		this.setState({ loading: true, errorMessage: '' });
		const { newEmail } = this.state;

		const updateData = await this.props.updateBillingEmail(newEmail);
		if (updateData.error) {
			this.setState({
				errorMessage:
					updateData.message ||
					'There was an error updating your billing email.',
			});
		} else {
			this.props.setBillingEmail(updateData.billingEmail || newEmail.trim());
			this.props.closeDialog();
		}
		this.setState({ loading: false });
	}

	renderButtons = () => {
		if (this.state.loading) {
			return (
				<div style={{ textAlign: 'center' }}>
					<CircularProgress />
				</div>
			);
		}
		return (
			<DialogActions>
				<Button
					variant="text"
					color="primary"
					onClick={() => this.props.closeDialog(false)}
				>
					Cancel
				</Button>
				<Button
					color="primary"
					variant="contained"
					onClick={this.submit}
				>
					Update
				</Button>
			</DialogActions>
		);
	};

	render() {
		return (
			<div>
				<TextField
					label="Email"
					variant="outlined"
					color="primary"
					fullWidth
					onChange={(event) => {
						this.setState({ newEmail: event.target.value });
					}}
				/>

				<Typography
					style={{ marginTop: 8, fontSize: '0.8rem', color: '#ef4444' }}
				>
					{this.state.errorMessage}
				</Typography>

				<div className="right-align">{this.renderButtons()}</div>
			</div>
		);
	}
}

export default connect(null, actions)(UpdateBillingEmailForm);



// WEBPACK FOOTER //
// ./src/components/settings/UpdateBillingEmailForm.js